import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-165">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" data-id="element-166"></div>

      {/* Attention Badge */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-[0_0_15px_rgba(239,68,68,0.15)]" data-id="element-167">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red animate-pulse shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-168"></span>
        <span className="hidden sm:inline" data-id="element-169">
          🤾 ATTENTION : ENTRAÎNEURS DE HANDBALL FATIGUÉS DE SACRIFIER LEURS
          NUITS À PLANIFIER
        </span>
        <span className="sm:hidden" data-id="element-170">
          🤾 ATTENTION : ENTRAÎNEURS DE HANDBALL
        </span>
      </motion.div>

      {/* Main headline */}
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} className="relative font-black text-text-main max-w-5xl text-[26px] leading-[1.15] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight" data-id="element-171">
        Votre saison{' '}
        <span className="relative inline-block" data-id="element-172">
          <span className="relative z-10" data-id="element-173">COMPLÈTE</span>
          <span className="absolute left-0 right-0 bottom-1 h-3 sm:h-4 bg-secondary/40 -z-0 -rotate-1" data-id="element-174"></span>
        </span>{' '}
        de Handball, prête en{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400" data-id="element-175">
          seulement 5 minutes.
        </span>
      </motion.h1>

      {/* Subheadline */}
      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} className="relative text-text-sec text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/5 sm:backdrop-blur-sm sm:border sm:border-white/10 sm:border-l-4 sm:border-l-primary sm:px-8 sm:py-5 sm:rounded-r-xl sm:shadow-2xl sm:text-left" data-id="element-176">
        Le Kit{' '}
        <span className="text-primary font-bold" data-id="element-177">"Ouvrez & Entraînez"</span>{' '}
        avec des séances prêtes pour les{' '}
        <span className="text-text-main font-bold" data-id="element-178">
          U10, U12, U15 et Gardiens
        </span>
        .{' '}
        <span className="hidden sm:inline text-text-main font-semibold" data-id="element-179">
          Récupérez vos week-ends.
        </span>
      </motion.p>

      {/* Mockup image */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.3,
      type: 'spring'
    }} className="relative w-full max-w-[300px] sm:max-w-[480px] md:max-w-[560px] mx-auto mb-4 sm:mb-8" data-id="element-180">
        <div className="absolute inset-0 bg-primary/20 blur-[60px] rounded-full" data-id="element-181"></div>
        <img src="https://cdn.magicpatterns.com/uploads/3pwHNUPk394PsogAqdG7er/15002B_CLIENTE_SODDISFATTI_(7).webp" alt="Pack Complet Handball Prêt - 6 volumes, desktop, tablette et mobile" className="relative w-full h-auto object-contain drop-shadow-2xl" data-id="element-182" />
      </motion.div>

      {/* Stars + Urgency */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.4
    }} className="relative flex flex-col items-center gap-2 sm:gap-2 mb-4 sm:mb-6" data-id="element-183">
        <div className="flex items-center gap-2" data-id="element-184">
          <span className="text-secondary text-sm sm:text-lg drop-shadow-[0_0_8px_rgba(245,158,11,0.5)]" data-id="element-185">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-186">
            4.9/5 (+500 Avis Vérifiés)
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-3 py-1 rounded-full border border-secondary/20" data-id="element-187">
          🔥 42 entraîneurs ont choisi ce Kit aujourd'hui
        </span>
      </motion.div>

      {/* CTA Button */}
      <motion.a initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-188">
        🚀 OUI ! JE VEUX RÉCUPÉRER MON TEMPS
      </motion.a>

      {/* Trust badges */}
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.6
    }} className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-189">
        <span data-id="element-190">⚡ Accès Immédiat</span>
        <span data-id="element-191">•</span>
        <span data-id="element-192">🛡️ Garantie 7 Jours</span>
        <span data-id="element-193">•</span>
        <span data-id="element-194">💳 Paiement Unique</span>
      </motion.p>
    </section>;
}